// extracted by mini-css-extract-plugin
export var brand = "_10-9";
export var button = "_10-0";
export var chevron = "_10-v";
export var chevronButton = "_10-w";
export var content = "_10-n";
export var danger = "_10-g";
export var dangerOutlined = "_10-h";
export var dark = "_10-l";
export var darkTheme = "_10-c";
export var extraSmall = "_10-4";
export var fullWidth = "_10-8";
export var ghost = "_10-d";
export var gray = "_10-t";
export var icon = "_10-p";
export var iconButton = "_10-s";
export var iconButtonBorder = "_10-x";
export var iconButtonBorderDark = "_10-y";
export var iconButtonBorderLight = "_10-z";
export var iconLeft = "_10-q";
export var iconRight = "_10-r";
export var large = "_10-1";
export var light = "_10-m";
export var medium = "_10-2";
export var micro = "_10-5";
export var nano = "_10-7";
export var outlined = "_10-k";
export var pending = "_10-a";
export var primary = "_10-i";
export var shadow = "_10-o";
export var small = "_10-3";
export var solidLight = "_10-e";
export var solidLightBrand = "_10-f";
export var spinner = "_10-u";
export var transparent = "_10-j";
export var warning = "_10-b";
export var wideNano = "_10-6";